import axios from 'axios';
import cookie from 'react-cookies';
import HttpService from 'services/http';

class AuthService {

  static login(filters) {
    return new Promise((resolve, reject) => {
      let path = '/login/';
      HttpService.post(path, filters).then((response) => {
        cookie.save('userId', response.id, {path: '/', maxAge: 24 * 60 * 60 });
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

  static logout() {
    return new Promise((resolve, reject) => {
      let path = '/logout/';
      HttpService.get(path).then((response) => {
        cookie.remove('userId', { path: '/' });
        resolve(response)
      }, (error) => {
        cookie.remove('userId', { path: '/' });
        reject(error);
      });
    });
  }

  static getUser() {
    return new Promise((resolve, reject) => {
      let path = '/users/me/';
      HttpService.get(path).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error);
      });
    });
  }

}

export default AuthService;


// WEBPACK FOOTER //
// ./services/auth.js